/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gd_Discord_DescInputs */

const en_gd_discord_desc = /** @type {(inputs: Gd_Discord_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join the Bystep community channel on Discord: ask anything, see how others solved the same thing.`)
};

const id_gd_discord_desc = /** @type {(inputs: Gd_Discord_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk ke kanal komunitas Bystep di Discord: tanya bebas, lihat cara orang lain menyelesaikan hal serupa.`)
};

/**
* | output |
* | --- |
* | "Join the Bystep community channel on Discord: ask anything, see how others solved the same thing." |
*
* @param {Gd_Discord_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const gd_discord_desc = /** @type {((inputs?: Gd_Discord_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gd_Discord_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_gd_discord_desc(inputs)
	return en_gd_discord_desc(inputs)
});